// Shared UI style constants
export const UI = {
  radius: "rounded-xl",
  border: "border border-slate-200",
  glass: "bg-white",
  transition: "transition-all",
  shadow: "shadow-md",
}

export const inputClass = "w-full px-4 py-3.5 bg-white text-slate-900 border border-slate-300 rounded-xl text-sm placeholder-slate-400"
